import React from "react";
import { useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Home from "@mui/icons-material/Home";
import TagIcon from "@mui/icons-material/Tag";
import AssistantIcon from "@mui/icons-material/Assistant";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import List from "@mui/material/List";

export const SideBarItems: React.FC = () => {
    const navigate = useNavigate();

    return (
        <List component="nav">
            <ListItemButton onClick={() => navigate("/")}>
                <ListItemIcon>
                    <Home />
                </ListItemIcon>
                <ListItemText primary="Home" />
            </ListItemButton>
            <ListItemButton onClick={() => navigate("/forum")}>
                <ListItemIcon>
                    <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Forum" />
            </ListItemButton>
            <ListItemButton onClick={() => navigate("/question/new")}>
                <ListItemIcon>
                    <LiveHelpIcon />
                </ListItemIcon>
                <ListItemText primary="Ask Question" />
            </ListItemButton>
            <ListItemButton onClick={() => navigate("/solution")}>
                <ListItemIcon>
                    <AssistantIcon />
                </ListItemIcon>
                <ListItemText primary="Ask AI" />
            </ListItemButton>
            <ListItemButton onClick={() => navigate("/tags")}>
                <ListItemIcon>
                    <TagIcon />
                </ListItemIcon>
                <ListItemText primary="Tags" />
            </ListItemButton>
        </List>
    );
};
